// Feature-definition names (the server feature-definitions catalog). Use with
// `useIsFeatureEnabled` (@app/services/organization-features) to gate UI on the
// org's effective feature state.
//
// Distinct from:
//  - permissions (auth grants, @app/constants/permissions / auth.permissions)
//  - SSM build-time flags (FEATURE_FLAG_* env vars)
export const QUIET_HOURS = 'QUIET_HOURS';
export const CENTRALIZED_QUIET_HOURS = 'CENTRALIZED_QUIET_HOURS';
export const CASE_SUMMARY = 'CASE_SUMMARY';
export const OUTBOUND_MEDIA = 'OUTBOUND_MEDIA';
